const firebaseConfig = {
    apiKey: "AIzaSyA0W9rw7A4kMM0INFGl-6ztqjR8ciW08ZI",
    authDomain: "travel-vacation-resort.firebaseapp.com",
    projectId: "travel-vacation-resort",
    storageBucket: "travel-vacation-resort.appspot.com",
    messagingSenderId: "787604272490",
    appId: "1:787604272490:web:83914bd31123546964e113"
  };
  export default firebaseConfig;